export default {
  topBarHeight: 50,
  boxShadowSubtle: "0 2px 6px rgba(0, 0, 0, 0.1)",
  fontStack: "'Open Sans', sans-serif"
};
